import { createApi } from '@reduxjs/toolkit/query/react';
import { isNil } from 'lodash';

import { BusinessPlan } from '../types/businessPlan';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

type FetchBusinessPlan = {
	companyId?: string | null;
};

const Tags = {
	BusinessPlan: 'businessPlan',
};

const baseUrl = 'businessplan';

export const businessPlanApi = createApi({
	reducerPath: 'businessPlanApi',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${config.COMPANY_API_URL}/${baseUrl}`),
	tagTypes: [Tags.BusinessPlan],
	endpoints: builder => ({
		fetchBusinessPlan: builder.query<BusinessPlan, FetchBusinessPlan>({
			query: ({ companyId }) => {
				if (isNil(companyId)) {
					throw new Error('parameter error');
				}
				return {
					method: 'GET',
					url: `/${companyId}`,
				};
			},
			providesTags: businessPlan => {
				return [{ type: Tags.BusinessPlan, id: businessPlan?.companyId ?? '' }];
			},
		}),
	}),
});

export const { useFetchBusinessPlanQuery } = businessPlanApi;
